import { useTranslation } from 'react-i18next';
import { EventLinearChartSectionSkeleton } from '@components/event-linear-chart-section-skeleton/event-linear-chart-section-skeleton';
import { EventReportHeaderSkeleton } from '@components/event-report-header-skeleton/event-report-header-skeleton';
import { EventReportHighlightSectionSkeleton } from '@components/event-report-highlight-section-skeleton/event-report-highlight-section-skeleton';

export const ReportPageSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className='relative'>
      <div className='w-5 h-5 bg-tertiary rounded-full mb-4 md:mb-6 mx-4 md:mx-0 animate-pulse' />
      <EventReportHeaderSkeleton />
      <EventReportHighlightSectionSkeleton
        title={t('eventReport:highlightsTitle')}
        subtitle={t('eventReport:hightlightsSubtitle')}
      />
      <EventLinearChartSectionSkeleton title={t('eventReport:performanceTitle')} />
    </div>
  );
};
